import { getMessages } from '../../../../../../store/constants';

export const TOOLTIP_BOARD = getMessages().getText('assigned_to_me.cards.tooltip.board');
export const TOOLTIP_LIST = getMessages().getText('assigned_to_me.cards.tooltip.list');
export const TOOLTIP_UPDATES = getMessages().getText('assigned_to_me.cards.tooltip.updates');

export const MY_WORK_CARD_HEIGHT = 44;
export const MY_WORK_CARDS_GROUP_MAX_CARDS_VISIBLE = 100;
